<script>
  export let visible = false;
  export let dismissable = false;

  function processDismiss() {
    console.log("dismiss processed");
  }
</script>

<style>
  .popout {
    background: white;
    box-shadow: var(--card-box-shadow);
    border: 1px solid var(--gray-light);
    border-radius: 5px;
    font-size: 1rem;
    position: absolute;
    padding: 1rem;
    top: 2rem;
    left: 0rem;
    width: 270px;
    z-index: 300;
  }

  .content {
    flex: 1;
  }

  .dismiss {
    background: none;
    border: none;
    color: var(--gray);
    font-size: 1.5rem;
    margin: 0;
    padding: 0;
    position: absolute;
    top: 0;
    right: 0.5rem;
  }

  .inactive {
    display: none;
  }
</style>

<aside class="popout" class:inactive={!visible}>
  <div class="content">
    <slot />
  </div>
  {#if dismissable}
    <button
      aria-label="close popout"
      title="close popout"
      class="dismiss"
      on:click={processDismiss}>
      &times;
    </button>
  {/if}
</aside>
